import { render, staticRenderFns } from "./SelectorCard.vue?vue&type=template&id=477c5852&"
import script from "./SelectorCard.vue?vue&type=script&lang=js&"
export * from "./SelectorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('477c5852')) {
      api.createRecord('477c5852', component.options)
    } else {
      api.reload('477c5852', component.options)
    }
    module.hot.accept("./SelectorCard.vue?vue&type=template&id=477c5852&", function () {
      api.rerender('477c5852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/selector/fragment/SelectorCard.vue"
export default component.exports